// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-uv9","colMin":"styles_colMin__1XCzt"};